/** Build-time configuration. Vite inlines VITE_* variables at build (web/.env.example).
 * No keys beyond the public Supabase anon key and analytics ingest keys ever live here
 * (R4: prompts, model ids and API keys stay server-side). */
const read = (value: string | undefined): string => (value ?? "").trim();

/** Fallback until the AppSource listing URL is set per environment (decisions.md). */
const APPSOURCE_SEARCH = "https://appsource.microsoft.com/en-us/marketplace/apps?search=SlideBrain&product=office%3Bpowerpoint";

export const env = {
  supabaseUrl: read(import.meta.env.VITE_SUPABASE_URL).replace(/\/+$/, ""),
  supabaseAnonKey: read(import.meta.env.VITE_SUPABASE_ANON_KEY),
  apiUrl: read(import.meta.env.VITE_API_URL).replace(/\/+$/, ""),
  /** "staging" / "local" show a badge and the sideload hint; empty in prod. */
  envLabel: read(import.meta.env.VITE_ENV_LABEL),
  posthogKey: read(import.meta.env.VITE_POSTHOG_KEY),
  posthogHost: read(import.meta.env.VITE_POSTHOG_HOST) || "https://eu.i.posthog.com",
  sentryDsn: read(import.meta.env.VITE_SENTRY_DSN),
  appSourceUrl: read(import.meta.env.VITE_APPSOURCE_URL) || APPSOURCE_SEARCH,
  /** The Entra app registration's client id: builds the admin-consent link. */
  entraClientId: read(import.meta.env.VITE_ENTRA_CLIENT_ID),
  /** Paddle.js client-side token (public by design): with it, checkout opens as an overlay
   * here; without it, the panel sends the buyer to the hosted checkout URL. */
  paddleClientToken: read(import.meta.env.VITE_PADDLE_CLIENT_TOKEN),
  /** "sandbox" for staging and local builds; empty for live. */
  paddleEnv: read(import.meta.env.VITE_PADDLE_ENV),
};
